import { render, staticRenderFns } from "./InvestorSituation.vue?vue&type=template&id=7a8aba65"
import script from "./InvestorSituation.vue?vue&type=script&lang=js"
export * from "./InvestorSituation.vue?vue&type=script&lang=js"
import style0 from "./InvestorSituation.vue?vue&type=style&index=0&id=7a8aba65&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports